import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b67f5b3")

_pushScopeId("data-v-3b67f5b3")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "download-btn p-ml-auto"
}
const _hoisted_3 = { class: "download-btn-panel" }
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "p-d-flex p-jc-between" }
const _hoisted_7 = { class: "p-grid p-m-0" }
const _hoisted_8 = {
  key: 0,
  class: "p-mt-1 p-mr-4 title-font"
}
const _hoisted_9 = { style: {"height":"40vh"} }
const _hoisted_10 = { class: "p-col-12" }
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_12 = { class: "p-mr-4 title-font" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "title-font" }, "[", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "title-font"
}
const _hoisted_16 = {
  key: 1,
  class: "title-font"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "title-font" }, "]", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ChartSettingsDialog = _resolveComponent("ChartSettingsDialog")!
  const _component_Prediction = _resolveComponent("Prediction")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_RunTable = _resolveComponent("RunTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.experimentDetail.status == 'COMPLETED' && _ctx.algorithmOptions.length)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              id: "download-btn",
              type: "Button",
              icon: "bx bx-download",
              class: "p-ml-auto p-button-outlined p-button-secondary",
              onClick: _ctx.toggle,
              "aria-haspopup": "true",
              "aria-controls": "overlay_panel",
              label: _ctx.$t('button.download.description')
            }, null, 8, ["onClick", "label"])
          ]),
          _createVNode(_component_OverlayPanel, {
            ref: "op",
            appendTo: "body",
            showCloseIcon: false,
            id: "overlay_panel"
          }, {
            default: _withId(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.algorithmOptions,
                selectionMode: "single",
                paginator: true,
                rows: 5,
                onRowSelect: _ctx.onAlgotithmSelect,
                responsiveLayout: "scroll"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    header: _ctx.$t('autots.evaluation.runTable.headers.algorithm')
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(slotProps.data.name)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"])
                ]),
                _: 1
              }, 8, ["value", "onRowSelect"])
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Summary, {
        experiment: _ctx.experimentDetail,
        datasourceConfig: _ctx.datasourceConfig[0],
        datasourceConfigDetail: _ctx.datasourceConfigDetail,
        bestKpi: _ctx.summaryKpi,
        metrics: _ctx.summaryMetrics,
        workspaceId: _ctx.workspaceId
      }, null, 8, ["experiment", "datasourceConfig", "datasourceConfigDetail", "bestKpi", "metrics", "workspaceId"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_ctx.timeSeriesIdentifierCandidateOption.length)
            ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("exp.label.choose.timeseries")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasourceConfig[0]?.timeSeriesIdentifiers, (value, index) => {
            return (_openBlock(), _createBlock("span", {
              class: "p-mb-5",
              key: index
            }, [
              _createVNode("label", {
                for: value,
                class: "p-mr-2"
              }, _toDisplayString(value), 9, ["for"]),
              _createVNode(_component_Dropdown, {
                id: value,
                class: "p-mr-4",
                modelValue: _ctx.timeSeriesIdentifierCandidateSelectedValue[index],
                "onUpdate:modelValue": ($event: any) => (_ctx.timeSeriesIdentifierCandidateSelectedValue[index] = $event),
                options: _ctx.timeSeriesIdentifierCandidateOption[index],
                placeholder: _ctx.datasourceConfig[0]?.timeSeriesIdentifiers[index],
                filter: true,
                onFilter: ($event: any) => (_ctx.onfilterChanged(value, index, $event)),
                optionLabel: "candidate",
                "virtual-scroller-options": {
                itemSize: 31,
              }
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options", "placeholder", "onFilter"])
            ]))
          }), 128))
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            label: _ctx.$t('experiment.evaluation.chart-settings'),
            onClick: _ctx.toggleChartSettings,
            "aria-haspopup": "true",
            "aria-controls": "chartSettingsOP"
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_OverlayPanel, {
            appendTo: "body",
            showCloseIcon: false,
            ref: "chartSettingsOP",
            id: "chartSettingsOP",
            style: {"width":"450px"}
          }, {
            default: _withId(() => [
              _createVNode(_component_ChartSettingsDialog, {
                "custom-chart-range": _ctx.chartSettings.customChartRange,
                "highlight-quantile": _ctx.chartSettings.highlightQuantile,
                "selected-chart-axis-option": 
                _ctx.chartSettings.selectedChartAxisOption
              ,
                "show-quantile": _ctx.chartSettings.showQuantile,
                "target-column": _ctx.datasourceConfig[0].targetColumn,
                onSaveSettings: _ctx.onSaveChartSettings,
                onCancelSettings: _ctx.onCancelChartSettings
              }, null, 8, ["custom-chart-range", "highlight-quantile", "selected-chart-axis-option", "show-quantile", "target-column", "onSaveSettings", "onCancelSettings"])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        (!_ctx.loadingPredictionGraphData)
          ? (_openBlock(), _createBlock(_component_Prediction, {
              key: 0,
              experiment: _ctx.experimentDetail,
              kpi: _ctx.kpi,
              "selected-chart-axis-option": _ctx.chartSettings.selectedChartAxisOption,
              "custom-chart-range": _ctx.chartSettings.customChartRange,
              "show-quantile": _ctx.chartSettings.showQuantile,
              "highlight-quantile": _ctx.chartSettings.highlightQuantile,
              currentType: _ctx.chartType,
              "onUpdate:currentType": _cache[1] || (_cache[1] = ($event: any) => (_ctx.chartType = $event)),
              selected: _ctx.selected,
              "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected = $event)),
              zoom: _ctx.zoom,
              "onUpdate:zoom": _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom = $event))
            }, null, 8, ["experiment", "kpi", "selected-chart-axis-option", "custom-chart-range", "show-quantile", "highlight-quantile", "currentType", "selected", "zoom"]))
          : (_openBlock(), _createBlock(_component_ProgressSpinner, {
              key: 1,
              class: "p-d-flex p-jc-between p-ai-center",
              style: {"height":"100%"}
            }))
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      (_ctx.timeSeriesIdentifierCandidateOption.length)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("exp.label.model.leaderboard.timeseries")), 1),
            _hoisted_13,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeSeriesIdentifierCandidateSelectedValue, (value, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                value
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      (
                _ctx.timeSeriesIdentifierCandidateSelectedValue.length - index === 1
              )
                        ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(value.candidate), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(value.candidate) + " /", 1))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _hoisted_17
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_RunTable, {
        id: '3d3ab77b-4766-466f-b3f3-5f4eb076de93',
        data: _ctx.runData,
        headers: _ctx.runTableHeaders,
        loading: _ctx.loading
      }, null, 8, ["data", "headers", "loading"])
    ])
  ]))
})